import * as fuzzysort from "fuzzysort";
import KeysOptions = Fuzzysort.KeysOptions;
import Options = Fuzzysort.Options;

/**
 * @returns Returns Results when handleFuzzySort is called with two arguments.
 * @param search - input query
 * @param data - input values to search
 */
export function handleFuzzySort(search: string, data: string[]): string[];

/**
 * function handleFuzzySort
 * @param search - The search string.
 * @param data - When handleFuzzySort is called with three arguments, data is an array of type T.
 * @param searchParameters - SearchParameters is an object that will accept 'keys' as an array of strings representing
 * the keys of the values in data to be searched.
 * @returns Returns an array of type T when handleFuzzySort is called with three arguments.
 */
export function handleFuzzySort<T>(search: string, data: T[], searchParameters: KeysOptions<T> | string): T[];

/**
 * Accepts any number of arguments based on the overloads and returns the result of the function call.
 * handleFuzzySort
 * @param arguments_ - either 2 or 3 arguments used to overload the function
 */
export function handleFuzzySort<T>(...arguments_: unknown[]): string[] | T[] {
  const defaultOptions: Options = {
    all: true,
    limit: Infinity,
    threshold: -10_000,
  };
  if (arguments_.length === 2) {
    const [search, data] = arguments_ as [string, string[]];

    if (search === "") return data;

    const results = fuzzysort.go(search, data, defaultOptions);
    return results.map((result) => result.target);
  }

  const [search, data, searchParameters] = arguments_ as [string, T[], KeysOptions<T> | string];

  if (search === "") return data;

  const keys = typeof searchParameters === "string" ? [searchParameters] : searchParameters.keys;
  const results = fuzzysort.go(search, data, { ...defaultOptions, keys });
  return results.map((result) => result.obj);
}
